<template>
    <div class="all" style="height: 700px;overflow-y: auto">
<!--    <span class="udl" style="display: inline-block;padding:15px 0 15px 16px ">订单详情({{add.code}})</span>-->
    <div class="orderID dfc" style="margin-top: 20px">
        <div style="width: 100%;background-color: #f2f2f2;height: 40px;padding: 10px 0 0 0;border-bottom: 1px solid #CCCCCC"><span class="biaotizi" style="margin-left: 10px;">订单编号&nbsp;{{data.code}}</span></div>
        <div style="display: flex">
            <div class="leftbox bd" style="width: 90%;padding: 12px">
                <p>订单状态:<span :class="data.status" style="margin-left: 19px">{{data.vc_status}}</span></p>
                <p style="padding-left: 14px">合同号:<span class="leftboxs" >{{data.vc_code}}</span></p>
                <p>销售公司:<span class="leftboxs" >{{add.vc_xsgsname}}</span></p>
                <p>下单时间:<span class="leftboxs" >{{data.dt_time}}</span></p>
                <div style="display: flex;align-items: center">付款时间:<span style="padding-left: 20px" v-if="data.payDate==''">暂无</span><span v-if="data.payDate!==''" class="leftboxs" >{{data.payDate}}</span></div>
                <p>配送方式:<span class="leftboxs" >{{data.vc_sendway}}</span></p>
                <div style="display: flex;margin-bottom: 10px"><div>{{data.isConsignShip=='HDDDA04'?'提货截止日期':'送货截止日期'}}:</div><span style="padding-left: 20px;" v-if="data.overdueTime==''">暂无</span><span class="leftboxs" v-if="data.overdueTime!==''">{{data.overdueTime}}</span></div>
                <div style="margin-left: 56px;display: flex;"><div>附件:</div><span style="padding-left: 20px" v-if="data.htName==''||data.yqname==''">暂无</span><div class="dfc" v-if="data.htName!==''"><a mce_href="#" :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+data.htNewName+'\'}','utf-8')" :download="data.htName" style="color: skyblue;margin-left: 20px"  >{{data.htName}}&nbsp; [下载]</a>
                    <div v-if="data.yqName!==''" class="dfc"><a mce_href="#" :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+data.yqNewName+'\'}','utf-8')" :download="data.yqName" style="color: skyblue;margin-left: 20px">{{data.yqName}}&nbsp; [下载]</a></div>
                </div>
                </div>
            </div>
            <div class="rightbox"style="width: 30%;padding:50px 16px  ">
                <p>买家账号:<span class="leftboxs" >{{data.vc_sendadd_lxr}}</span><a href="#" style="color:rgb(63,167,243);">[联系买家]</a></p>
                <div style="margin-left: 13px;display: flex;align-items: center"><p style="min-width: 60px">手机号:</p><span  style="display: flex;min-width: 100px;margin-left: 5px">{{data.vc_sendadd_lxr_tel}}</span></div>
                <p>购买公司:<span class="leftboxs">{{data.vc_gmgsname}}</span></p>
            </div>
        </div>
    </div>
    <div class="goods" style="border:1px solid #CCCCCC;margin: 20px 0 0 0;width: 90%">
        <div class="zi" style="width: 100%;background-color: #f2f2f2;padding: 10px 0 0 0 ;border-bottom: 1px solid #CCCCCC"><span class="biaotizi" style="margin-left: 10px">商品信息</span></div>
        <div style="display: flex">
                <div class="content1 bd" style="width: 40% ;min-width: 345px " >
                <div class="numb" style="display: flex;justify-content: space-between;padding: 12px 12px" v-for="(val,index) in data.goods" :key="index">
                    <div class="left" style="display:flex" >
                        <div style="height: 40px;width: 40px;display: flex"><img style="width: 100%" :src="val.imageHeader+val.imagePath"></div>
                        <div class="dfc" style="margin-left: 10px">
                            <div class="hzt">✕{{val.f_num}}件</div>
                            <div class="yc">{{val.pzName}}</div>
                            <div class="guige">{{val.vc_bzstyle}}</div>>
                        </div>
                    </div>
                    <div class="right dfc"  style="text-align: end">
                        <p style="color: red;padding: 0;margin: 0;min-width: 70px">{{val.vc_ename}}{{fun(val.f_price)}}</p>
                        <span style="padding: 0;margin: 0;min-width: 70px" class="hzt">✕{{val.f_num}}吨</span>
                    </div>
                </div>
            </div>
            <div class="wbd bd" ><span>订单合计:</span><span>{{data.goods[0].vc_ename}}{{fun()}}</span><span class="hzt">(含运费:{{data.currency_ename}}{{fun(data.freightPrice)}})</span></div>
            <div class="wbd bd"  ><span>仓储费:</span><span>{{data.goods[0].vc_ename}}{{fun(data.yqPrice)}}</span></div>
            <div class="wbd" ><span>待支付:</span><span style="color:skyblue;">{{data.currency_ename}}{{fun(data.waitPayPrice)}}</span></div>
        </div>
    </div>
    <div class="details" style="border:1px solid #CCCCCC;margin: 20px 0 20px 0;width: 90%;">
        <div class="zi" style="width: 100%;background-color: #f2f2f2;height: 40px;padding: 10px 0 0 0 ;border-bottom: 1px solid #CCCCCC"><span class="biaotizi" style="margin-left: 10px">配送详情</span></div>
        <div style="padding: 12px 0 0 12px">{{data.isConsignShip=='HDDDA04'?'提货仓库':'送货地址'}}:<span style="padding-left: 20px" v-if="data.isConsignShip=='HDDDA04'">{{data.ckName}}</span>
            <span class="hzt" style="padding-left: 22px" v-if="data.isConsignShip=='HDDDA03'">{{data.targetUser}}<span style="padding-left: 5px">{{data.targetTel}}</span> <span style="padding-left: 5px">{{data.targetAddress}}</span> </span>
        </div>
        <div style="padding: 10px 0 0 12px;display: flex" ><div>{{data.isConsignShip=='HDDDA04'?'提货单号':'送货单号'}}:</div>
            <span  style="padding-left: 20px" v-if="thlistlen==0">暂无</span>
            <div class="dfc" v-if="thlistlen>0"><span style="padding-left: 20px" v-for="(val,index) in data.thList" :key="index">{{val.state}}&nbsp;<span style="color:skyblue;">{{val.order_no}}&nbsp;</span>{{val.pzName}}</span></div></div>
        <div style="display: flex;padding: 10px 0 7px 26px"><div>{{data.isConsignShip=='HDDDA04'?'待提货':'待发货'}}:
        </div>
            <div class="dfc"  ><span style="padding-left: 20px" v-for="(val,index) in data.dhList" :key="index">{{val.pzName}}&nbsp; ✕{{val.num}}件 &nbsp; ({{val.perWeight}}{{val.unit}})</span>

        </div>
        </div>
    </div>
    </div>
</template>
<script>
    import * as API from  "../api";
    import {mapActions} from "vuex";
    import {file_url} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    export default {
        name: 'Dialog',
        props:{
            add:{
                type:Object,
                required:true
            },
            mid:{
                type:[Object,Number,String,Array],
                required:true
            }
        },
        data() {
            return {
                file_url:'',
                baseApp:'',
                baseVersion:'',
                token:"",
                i_uid:"",
                data:{},
                timeLineHeight: "",
                fujian:[],
                goodslen:0,
                thlistlen:0,
                mud:this.mid
            }
        },
        mounted() {

            this.getOrderDetail(),
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            fun(val){
                return Number(val).toFixed(2)
            },
            async getOrderDetail(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                //console.log(result,this.add.i_id)
                if (result.i_id !== "") {
                    this.mud = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mud = sessionStorage.getItem('mids')
                };

                let param={
                    id:this.add.i_id
                };
                let res=await API.getOrderDetails(param)
                //console.log(res)
                if(res.code==1){
                    this.data=res.data
                    // console.log(this.data)
                 this.fujian.push(this.data.htName,this.data.yqName)
                    // console.log(this.fujian)
                    this.goodslen=this.data.goods.length
                    this.thlistlen=this.data.thList.length
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .HTSOS04_01{
        color: rgb(57,179,74);
    }
    /deep/.HTSOS04_02{
        color: rgb(57,179,74);
    }   /deep/.HTSOS04_03{
            color: rgb(57,179,74);
        }
    /deep/.HTSOS02{
        color: rgb(255,145,30);
    }
    /deep/.HTSOS09{
        color: rgb(102,102,102);
    }
    /deep/.HTSOS10{
        color: rgb(102,102,102);
    }
    /deep/.HTSOS06{
        color: rgb(102,102,102);
    }
    /deep/.HTSOS07{
        color: rgb(253,135,177);
    }
    /deep/.HTSOS05{
        color: rgb(69,169,243);
    }
    /deep/.HTSOS08{
        color: rgb(255,145,30);
    }
    .hzt{
        color: rgb(134,134,134);
    }
    .yc{


        overflow:hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        -webkit-text-overflow:ellipsis;//safari浏览器
        text-overflow:ellipsis;//opera浏览器
        width:200px;
    }
    .all{
        display: flex;
        /*justify-content: center;*/
        flex-direction: column;
        align-items: center;
        /*padding-top:500px ;*/
    }

    /deep/.content1 .numb:last-child{
        border: none    ;
    }
    /deep/.content1 .numb{
        border-bottom: 1px solid #CCCCCC    ;
    }
    .orderID{

        width: 90%;
        border: 1px solid #CCCCCC;
    }
    .bdt{
        border-bottom: 1px solid #CCCCCC;
    }
    .leftboxs{
        margin-left: 19px
    }
    .wbd{
        width: 20%;
        display: flex;justify-content: center;align-items: center;flex-direction: column
    }
    .bd{
        border-right: 1px solid #e0e0e0;
    }
    .dfc{
        display: flex;flex-direction: column
    }
    .biaotizi{
        font-size: 15px;font-weight: bold;color: #666
    }
</style>